/**
 * PrepStatusControls — the New Business Assistant's status buttons on an
 * opened preparation request (CLAUDE.md §28.2 / §40): Start preparation,
 * Revert to Inbox, Mark complete (gated by an unacknowledged amendment,
 * §26.8) and Reopen. The handlers stay in PrepRequestDetail.jsx — they
 * call prepPipelineService and own the dashboard return (§39) — and are
 * passed in under their own names; the `isNB &&` guard stays at the call
 * site. Extracted verbatim (step P6c of the PrepRequestDetail
 * decomposition, audit §6.2); the moved block keeps its original
 * indentation.
 */

import { Play, CheckSquare, Undo2 } from 'lucide-react';

export default function PrepStatusControls({
  prep,
  busy,
  amendmentPending,
  startPreparation,
  revertToSubmitted,
  handleMarkComplete,
  reopenToInProgress,
}) {
  return (
        <div style={styles.actions}>
          {prep.status === 'submitted' && (
            <button className="btn btn-primary" onClick={startPreparation} disabled={busy}>
              <Play size={16} /> Start preparation
            </button>
          )}
          {prep.status === 'in_progress' && (
            <>
              <button className="btn btn-secondary" onClick={revertToSubmitted} disabled={busy}>
                <Undo2 size={16} /> Revert to Inbox
              </button>
              <button
                className="btn btn-primary"
                onClick={handleMarkComplete}
                disabled={busy || amendmentPending}
                title={amendmentPending
                  ? 'The task list was amended — read the changes first.'
                  : undefined}
              >
                <CheckSquare size={16} /> Mark complete
              </button>
            </>
          )}
          {prep.status === 'completed' && (
            <button className="btn btn-secondary" onClick={reopenToInProgress} disabled={busy}>
              <Undo2 size={16} /> Reopen (back to In Progress)
            </button>
          )}
        </div>
  );
}

// The actions row style, also read by the amend row and the Adviser's
// post-completion row that remain in PrepRequestDetail.jsx; defined once
// here, re-attached there as a reference. View -> component only.
export const styles = {
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '0.6rem',
    marginTop: '1.25rem',
    flexWrap: 'wrap',
  },
};
